var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlxLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 40,
    viewBox: "0 0 79 40",
    fill: "#262626",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.7447 27.0485L70.1161 19.4663L77.7485 11.8338L78.4255 11.1568L77.7485 10.4799L72.6383 5.36961L71.9613 4.69263L71.2843 5.36961L63.6518 13.0021L56.0696 5.37348L55.3926 4.69263L54.7118 5.36961L49.6015 10.4799L48.9284 11.1568L49.5977 11.8338L57.1876 19.4663L49.6015 27.0524L48.9246 27.7294L49.6015 28.4064L54.7118 33.5166L55.3888 34.1936L56.0658 33.5166L63.6518 25.9305L71.2882 33.5205L71.9613 34.1936L72.6383 33.5166L77.7485 28.4064L78.4255 27.7255L77.7447 27.0485Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3845 4.24371V40H44.87V0L35.3845 4.24371Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1199 25.7718C19.9574 28.8202 17.4352 31.2457 14.3443 31.2457C11.2534 31.2457 8.56093 28.6577 8.56093 25.4623C8.56093 22.267 11.1489 19.679 14.3443 19.679C17.5397 19.679 19.9574 22.1045 20.1199 25.1528V25.7718ZM20.1199 11.0793V12.3327C18.352 11.5552 16.3985 11.118 14.3443 11.118C6.42167 11.1219 0 17.5397 0 25.4623C0 33.385 6.42167 39.8066 14.3443 39.8066C16.3985 39.8066 18.352 39.3695 20.1199 38.5919V40H29.6054V11.0832H20.1199V11.0793Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlxLogoBlack);
export default __webpack_public_path__ + "static/media/Alx-logo-black.2c61c45f23a21f17cd15e4aa4da6c3f6.svg";
export { ForwardRef as ReactComponent };